/**
 * Arte da landing em `public/entrada/landing/`. O nome leva a versão (`-v1`) porque o nginx
 * guarda `/entrada/` por 7 dias: trocar uma imagem é subir a versão dela em VERSAO e as larguras.
 */
const PASTA = '/entrada/landing';

export type Fundo = 'heroi' | 'final';
export type Tela = 'minoc' | 'cemiterio' | 'destard' | 'mina';

/** As telas do jogo de 21/10/2026 (HUD v3, montaria): Minoc foi para a v2; Destard e a mina entraram. */
const VERSAO: Readonly<Record<Fundo | Tela, string>> = {
  heroi: 'v1', final: 'v1', minoc: 'v2', cemiterio: 'v1', destard: 'v1', mina: 'v1'
};

/** Larguras geradas para cada imagem: a menor e a cheia. */
export const LARGURAS: Readonly<Record<Fundo | Tela, readonly [number, number]>> = {
  heroi: [800, 1280],
  final: [800, 1280],
  minoc: [960, 1915],
  cemiterio: [960, 1691],
  destard: [960, 1907],
  mina: [960, 1913]
};

const FORMATOS = [['avif', 'image/avif'], ['webp', 'image/webp'], ['jpg', 'image/jpeg']] as const;

export function arquivo(nome: Fundo | Tela, largura: number, ext: 'avif' | 'webp' | 'jpg'): string {
  return `${PASTA}/${nome}-${VERSAO[nome]}-${largura}.${ext}`;
}

/** Valor de `--img-heroi` / `--img-final`: o navegador escolhe o formato. */
export function fundoCss(nome: Fundo, largura: number): string {
  const opcoes = FORMATOS.map(([ext, tipo]) => `url("${arquivo(nome, largura, ext)}") type("${tipo}")`);
  return `image-set(${opcoes.join(', ')})`;
}

/** `<source>` de uma tela da galeria, nas duas larguras. */
export function fontesDaTela(nome: Tela): { readonly tipo: string; readonly srcSet: string }[] {
  const [menor, cheia] = LARGURAS[nome];
  return FORMATOS.slice(0, 2).map(([ext, tipo]) => ({
    tipo,
    srcSet: `${arquivo(nome, menor, ext)} ${menor}w, ${arquivo(nome, cheia, ext)} ${cheia}w`
  }));
}
